import { CommonModule } from '@angular/common';
import { Component, Inject, NgZone } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

interface ViewDialogData {
	title: string;
	data: any;
}

@Component({
	selector: 'app-calender-dialog-modal',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule
  ],
	templateUrl: './custom-calender-dialog.component.html',
  styleUrls: ['./custom-calender-dialog.component.scss']
})
export class ModalCalenderDialogComponent {
	public errorMessage: string = '';
  public loading: boolean = false;
  public hasFormErrors: boolean = false;
	public enddatetime: Date;
	public location: string = '';
	public subject: string = '';
	public remainder: string = '';
	public startdatetime: Date;

	constructor(private zone: NgZone,
		public dialogRef: MatDialogRef<ModalCalenderDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: ViewDialogData) {
			// console.log('ModalGalleryDialogComponent', data);
	}
	closeModal(data): void {
		this.zone.run(() => {
		   this.dialogRef.close(data);
		});
  }
  confirmModal(): void {
		let startDate = '';
		let endDate = '';
		if(this.startdatetime){
			startDate = (new Date(this.startdatetime)).toUTCString();
		}
		if(this.enddatetime){
			endDate = (new Date(this.enddatetime)).toUTCString();
		}
		this.zone.run(() => {
		   this.dialogRef.close({subject: this.subject, enddatetime: endDate, location: this.location, remainder: this.remainder, startdatetime: startDate});
		});
  }
}
